import * as d3 from "d3";

export function summaryStats(values) {
  const v = values.filter((x) => Number.isFinite(x)).sort(d3.ascending);
  if (v.length === 0) return null;

  const q1 = d3.quantileSorted(v, 0.25);
  const med = d3.quantileSorted(v, 0.5);
  const q3 = d3.quantileSorted(v, 0.75);
  const iqr = q3 - q1;

//   const loFence = q1 - 1.5 * iqr;
//   const hiFence = q3 + 1.5 * iqr;

  // whiskers inside fences
//   const loWhisker = v.find((x) => x >= loFence) ?? v[0];
//   const hiWhisker =
//     [...v].reverse().find((x) => x <= hiFence) ?? v[v.length - 1];

//   const outliers = v.filter((x) => x < loFence || x > hiFence);
  const mean = d3.mean(v);
  //   console.log("outlier", outliers);

  return {
    q1,
    med,
    q3,
    iqr,
    // loWhisker,
    // hiWhisker,
    // outliers,
    mean,
    n: v.length,
  };
}